// extracted by mini-css-extract-plugin
export default {"notice":"Notice_notice__pJQaI","container":"Notice_container__3UGH1","body":"Notice_body__gtpsF","close":"Notice_close__F0xs8"};